"use client";

import React from "react";
import Link from "next/link";
import Image from "next/image";

const WhiteningCost: React.FC = () => {
  return (
    <section className="w-full py-6 sm:py-8 bg-gradient-to-b from-white to-gray-50">
      <div className="max-w-6xl mx-auto px-4 sm:px-8 md:px-12 space-y-6 text-center md:text-left">
        <h2
          className="
            text-2xl sm:text-3xl font-semibold text-gray-800 text-center
            pb-6 after:content-[''] after:block after:w-[200px] after:h-[3px] after:mx-auto after:mt-2
            after:bg-[linear-gradient(to_right,#AE7D2F_0%,#ECD05B_50%,#AE7D2F_100%)]
          "
        >
          How Much Does Teeth Whitening Cost in Astoria, NY?
        </h2>
        <div className="relative w-full h-[300px] md:h-[500px] my-8 rounded-lg overflow-hidden shadow-lg">
          <Image
            src="/images/Photo-a-close-up-of-a-dentist-wearing-blue-nitrile-gloves-performing-a-clinical-oral-examination-on-a-male-patient-by-gently-holding-his-lips-open.jpeg"
            alt="Dentist performing a clinical oral examination on a patient at Smile4Me Dental Care"
            fill
            className="object-cover"
            sizes="(max-width: 768px) 100vw, 50vw"
          />
        </div>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Pricing varies depending on the treatment type. Here&apos;s a general
          overview:
        </p>

        <div className="overflow-x-auto">
          <table className="w-full max-w-2xl mx-auto border-collapse text-left text-gray-700 text-base sm:text-lg">
            <thead>
              <tr className="border-b-2 border-gray-300">
                <th className="py-3 px-4 font-semibold text-gray-800">
                  Treatment Type
                </th>
                <th className="py-3 px-4 font-semibold text-gray-800">
                  Approximate Cost Range
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="border-b border-gray-200">
                <td className="py-3 px-4">In-office professional whitening</td>
                <td className="py-3 px-4">$300&ndash;$600</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="py-3 px-4">Dentist-provided take-home kit</td>
                <td className="py-3 px-4">$150&ndash;$400</td>
              </tr>
              <tr className="border-b border-gray-200">
                <td className="py-3 px-4">Over-the-counter strips/kits</td>
                <td className="py-3 px-4">$20&ndash;$80</td>
              </tr>
            </tbody>
          </table>
        </div>

        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Professional whitening costs more upfront. It delivers stronger
          formulas, custom application, and dentist supervision. Whitening is
          generally considered cosmetic and is not covered by dental insurance.
        </p>
        <p className="text-gray-700 text-base sm:text-lg leading-relaxed group hover:bg-gray-50 transition-all duration-300 rounded-md py-1">
          Smile4Me offers{" "}
          <Link
            href="/financing-insurance/"
            className="inline-block bg-gradient-to-r from-[#AE7D2F] via-[#ECD05B] to-[#AE7D2F] bg-clip-text text-transparent hover:underline transition-all duration-300 ease-in-out"
            aria-label="Flexible financing options at Smile4Me Dental Care"
          >
            flexible financing options
          </Link>{" "}
          to make professional whitening more accessible. Contact our office for
          current financing details.
        </p>
      </div>
    </section>
  );
};

export default WhiteningCost;
